export default __webpack_public_path__ + "static/media/4_5-card.7f70ba70.png";